import ApiService from '../api.service';

const OfferCreditResource = {
  index: (params) => ApiService.query(`/v1/business/${params.business_id}/offer_credits`, params),
};

export default OfferCreditResource;
